import { ContentData } from "../../src/apis/stateful-content";
import { ColumnTypes } from "../../src/components/stateful-content/stateful-table/column-types";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;
import { StatusType } from "@trumpf/ux.ui-widgets/dist/collection/components/status/status-types";

const active: StatusType = "SERVICE_AGREEMENT_Active";
const inactive: StatusType = "SERVICE_AGREEMENT_Inactive";

const response: ContentData = {
    totalCount: 62,
    filteredCount: 10,
    labelCount: "Treffer",
    schema: {
        isFav: {
            type: ColumnTypes.FavToggle,
            sortable: true,
            "primary-mobile": false,
        },
        name: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": true,
        },
        number: {
            type: ColumnTypes.Hidden,
            sortable: true,
            "primary-mobile": true,
        },
        latestAvailableVersion: {
            type: ColumnTypes.LatestAvailableSoftwareVersion,
            sortable: true,
            "primary-mobile": false,
        },
        serviceAgreementStatus: {
            type: ColumnTypes.Status,
            sortable: true,
            "primary-mobile": false,
        },
        detailLink: {
            type: ColumnTypes.DetailLink,
            sortable: false,
            "primary-mobile": false,
        },
    },
    items: [
        {
            name: "Demo TruTops Boost TEST",
            number: "TWDEDM103001",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "9.5", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: true,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902844527&cHash=d106e51f0794be48661e811712e685e2",
        },
        {
            name: "Materialdescription for 1948519",
            number: "TWDEDM103002",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "11.02.22.00",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: true,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902898715&cHash=ef80c4e3827165d5d7eb457f160b9c57",
        },
        {
            name: "PC-Transfer",
            number: "TWDEDM103003",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "4.20.00.0",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: true,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900751944&cHash=07552b60f524d1fa18bb140309c09a5c",
        },
        {
            name: "PC-Transfer",
            number: "TWDEDM103004",
            serviceAgreementStatus: active,
            latestAvailableVersion: {
                version: "4.20.00.0",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900554940&cHash=62a5637d120c39f1f11f79aa5bc4ed71",
        },
        {
            name: "TruTops",
            number: "TWDEDM103005",
            serviceAgreementStatus: active,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900554948&cHash=2125d5bcf5f245aff1971c3b363798f8",
        },
        {
            name: "TruTops",
            number: "TWDEDM103006",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900567842&cHash=24ee823e7279418d1e1dc42b32b17907",
        },
        {
            name: "TruTops",
            number: "TWDEDM103007",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900751948&cHash=18e6535bcce9753ad00c8901d15ed5b6",
        },
        {
            name: "TruTops",
            number: "TWDEDM103008",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=901666472&cHash=4bdb9b5e8bc3e43d2f67401a1c52da07",
        },
        {
            name: "TruTops",
            number: "TWDEDM103009",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902377822&cHash=555f455649ec8bee5dd2b6a36531a280",
        },
        {
            name: "TruTops Bend",
            number: "TWDEDM1030010",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900555353&cHash=2044db772d6f1f0bac8bad64cf950c26",
        },
        {
            name: "TruTops Bend",
            number: "TWDEDM1030011",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900567850&cHash=42db2125462545372787ad4c8ff54afd",
        },
        {
            name: "TruTops Boost 1.Liz.",
            number: "TWDEDM1030012",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "8.4", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902792365&cHash=70661c8bd01f127bb95ab0634c7dd2cb",
        },
        {
            name: "TruTops Boost 1.Liz.",
            number: "TWDEDM1030013",
            serviceAgreementStatus: active,
            latestAvailableVersion: {
                version: "12.04.21.00",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902930074&cHash=f9ae043c620ec13ff8e6b0d0e2fdec16",
        },
        {
            name: "TruTops Boost 1.Liz.",
            number: "TWDEDM1030014",
            serviceAgreementStatus: active,
            latestAvailableVersion: {
                version: "14.06.21.00",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902967741&cHash=65d3e39fc381782e5e616c51293c09f6",
        },
        {
            name: "TruTops CAD",
            number: "TWDEDM1030015",
            serviceAgreementStatus: active,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900554976&cHash=45539ce2e7b991f2e61ead201b323dcc",
        },
        {
            name: "TruTops CAD",
            number: "TWDEDM1030016",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900567897&cHash=6061a48c1c322a64205ca8b16d95523b",
        },
        {
            name: "TruTops CAD",
            number: "TWDEDM1030017",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=901666469&cHash=b3c252ee01988a09cbac0b7f217a4d30",
        },
        {
            name: "TruTops CAD",
            number: "TWDEDM1030018",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902377819&cHash=1b40bc4a331b074a2c06802f0c576684",
        },
        {
            name: "TruTops Cell",
            number: "TWDEDM1030019",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "09.06.00", hasUpdates: true },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=901367803&cHash=4ede4d1a715c7dd8e5ab99edc311cfd4",
        },
        {
            name: "TruTops Cell",
            number: "TWDEDM1030020",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "9.00.00.0", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=901557016&cHash=6db0e223c86078297efc22467d49c4cf",
        },
        {
            name: "TruTops Cell",
            number: "TWDEDM1030021",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "8.01.00.0", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902128054&cHash=ae2a8d9170d737b73216c8e81f139c87",
        },
        {
            name: "TruTops Cell",
            number: "TWDEDM1030022",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "7.01.00.0", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902129449&cHash=0cca5497b5e210d1acbcc468abdd4d3b",
        },
        {
            name: "TruTops Cell",
            number: "TWDEDM1030023",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "8.01.00.0", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902377795&cHash=de026ea84c5d8dbf607c80508e799340",
        },
        {
            name: "TruTops Fab",
            number: "TWDEDM1030024",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "16.05.20.00",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902792366&cHash=b7cd34d9d2d25f66004300b9bb01645e",
        },
        {
            name: "TruTops Fab",
            number: "TWDEDM1030025",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "21.04.21.00",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902930075&cHash=ae8dbb09016f02de6fc559c76c9aa234",
        },
        {
            name: "TruTops Fab",
            number: "TWDEDM1030026",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "22.05.22.01",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902967742&cHash=c0881afeae6b517f26215bd8ab70de87",
        },
        {
            name: "TruTops Laser (metrisch)",
            number: "TWDEDM1030027",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900751982&cHash=4cb2caecf9883d9482fd3e60f0fc4427",
        },
        {
            name: "TruTops Laser (metrisch)",
            number: "TWDEDM1030028",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=901666457&cHash=ebd5686921245da4377660b1106a4787",
        },
        {
            name: "TruTops Laser (metrisch)",
            number: "TWDEDM1030029",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: false,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902128049&cHash=8cccc63124c997c3c15252cc4d110e9a",
        },
        {
            name: "TruTops Laser (metrisch)",
            number: "TWDEDM1030030",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: { version: "11.6", hasUpdates: false },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=902377781&cHash=94b98bfb4172f21e2e4912dc2610fca8",
        },
        {
            name: "TruTops Punch (metrisch)",
            number: "TWDEDM1030031",
            serviceAgreementStatus: inactive,
            latestAvailableVersion: {
                version: "12.00.00.01",
                hasUpdates: true,
            },
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            detailLink:
                "http://trumpf.local.tru/de_DE/mytrumpf/meine-factory/meine-software/?tx_mytrumpf_mytrumpfshowsoftware%5Baction%5D=detail&tx_mytrumpf_mytrumpfshowsoftware%5Bcontroller%5D=MySoftware%5CSoftware&tx_mytrumpf_mytrumpfshowsoftware%5BproductNumber%5D=900555040&cHash=c87bc49f5c140c29040313d5d11bd1aa",
        },
    ],
};

const emptyResponse: ContentData = {
    totalCount: 0,
    filteredCount: 0,
    labelCount: "Treffer",
    items: [],
    error: {
        head: "Sie besitzen noch keine Trumpf Software",
        copy:
            "Lernen sie unser umfangreiches Software Portfolio kennen und kontaktieren sie ihren zuständigen Trumpf Ansprechpartner.",
    },
};

const writeToFile = (object: ContentData, name: string) => {
    console.log(JSON.stringify(object));
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

const response2FilteredCount = 20;
const response3FilteredCount = 30; 

const response1 = {
    ...response,
    nextPage: `generated-mock-data/mysoftware-page2.json`,
};

const response2 = {
    ...response,
    filteredCount: response2FilteredCount,
    nextPage: `generated-mock-data/mysoftware-page3.json`,
    items: response.items.map((item) => ({ ...item, name: item.name + " 2" })),
};

const response3 = {
    ...response,
    filteredCount: response3FilteredCount,
    nextPage: null,
    items: response.items.map((item) => ({ ...item, name: item.name + " 3" })),
};

writeToFile(response1, "mysoftware");
writeToFile(response2, "mysoftware-page2");
writeToFile(response3, "mysoftware-page3");
writeToFile(emptyResponse, "mysoftware-empty");
